import { KeyValue } from "@/main/models/common";
import { IntegrationQueueServiceRequest } from "@/main/models/request";
import { IntegrationInterfaceFilter } from "@/main/models/request/integrationRequest";
import { IntegrationInterfaceResponse } from "@/main/models/response";

export enum IntegrationTypes {
	GET_DOMAIN = "@integration/GET_DOMAIN",
	SAVE_DOMAIN = "@integration/SAVE_DOMAIN",
	RESET_REDUCER_DOMAIN = "@integration/RESET_REDUCER_DOMAIN",
	GET_SERVICE = "@integration/GET_SERVICE",
	SAVE_SERVICE = "@integration/SAVE_SERVICE",
	RESET_REDUCER_SERVICE = "@integration/RESET_REDUCER_SERVICE",
	GET_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES = "@integration/GET_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES",
	SAVE_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES = "@integration/SAVE_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES",
	RESET_REDUCER_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES = "@integration/RESET_REDUCER_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES",
	GET_INTEGRATION_INTEGRATION_INTERFACE = "@integration/GET_INTEGRATION_INTEGRATION_INTERFACE",
	SAVE_INTEGRATION_INTEGRATION_INTERFACE = "@integration/SAVE_INTEGRATION_INTEGRATION_INTERFACE",
	RESET_REDUCER_INTEGRATION_INTEGRATION_INTERFACE = "@integration/RESET_REDUCER_INTEGRATION_INTEGRATION_INTERFACE",
	GET_INTEGRATION_INTERFACE = "@integration/GET_INTEGRATION_INTERFACE",
	SAVE_INTEGRATION_INTERFACE = "@integration/SAVE_INTEGRATION_INTERFACE",
	RESET_REDUCER_INTEGRATION_INTERFACE = "@integration/RESET_REDUCER_INTEGRATION_INTERFACE",
}

export interface IntegrationState {
	readonly domain: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};

	readonly service: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};

	readonly integrationIntegrationInterfacesByGuidIntegration: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};

	readonly integrationIntegrationInterface: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};

	readonly integrationInterface: {
		data: IntegrationInterfaceResponse[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetDomain {
	type: typeof IntegrationTypes.GET_DOMAIN;
}

export interface SaveDomain {
	type: typeof IntegrationTypes.SAVE_DOMAIN;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerDomain {
	type: typeof IntegrationTypes.RESET_REDUCER_DOMAIN;
}

export interface GetService {
	type: typeof IntegrationTypes.GET_SERVICE;
	payload: number;
}

export interface SaveService {
	type: typeof IntegrationTypes.SAVE_SERVICE;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerService {
	type: typeof IntegrationTypes.RESET_REDUCER_SERVICE;
}

export interface GetDomainIntegrationIntegrationInterfaces {
	type: typeof IntegrationTypes.GET_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES;
	payload: IntegrationQueueServiceRequest;
}

export interface SaveDomainIntegrationIntegrationInterfaces {
	type: typeof IntegrationTypes.SAVE_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerDomainIntegrationIntegrationInterfaces {
	type: typeof IntegrationTypes.RESET_REDUCER_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES;
}

export interface GetIntegrationIntegrationInterface {
	type: typeof IntegrationTypes.GET_INTEGRATION_INTEGRATION_INTERFACE;
	payload: {
		guidIntegrationInterface: string | null;
	};
}

export interface SaveIntegrationIntegrationInterface {
	type: typeof IntegrationTypes.SAVE_INTEGRATION_INTEGRATION_INTERFACE;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerIntegrationIntegrationInterface {
	type: typeof IntegrationTypes.RESET_REDUCER_INTEGRATION_INTEGRATION_INTERFACE;
}

export interface GetIntegrationInterface {
	type: typeof IntegrationTypes.GET_INTEGRATION_INTERFACE;
	payload: {
		integrationInterfaceFilter: IntegrationInterfaceFilter;
	};
}

export interface SaveIntegrationInterface {
	type: typeof IntegrationTypes.SAVE_INTEGRATION_INTERFACE;
	payload: {
		data: IntegrationInterfaceResponse[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerIntegrationInterface {
	type: typeof IntegrationTypes.RESET_REDUCER_INTEGRATION_INTERFACE;
}

export type IntegrationActionTypes =
	| GetDomain
	| SaveDomain
	| ResetReducerDomain
	| GetService
	| SaveService
	| ResetReducerService
	| GetDomainIntegrationIntegrationInterfaces
	| SaveDomainIntegrationIntegrationInterfaces
	| ResetReducerDomainIntegrationIntegrationInterfaces
	| GetIntegrationIntegrationInterface
	| SaveIntegrationIntegrationInterface
	| ResetReducerIntegrationIntegrationInterface
	| GetIntegrationInterface
	| SaveIntegrationInterface
	| ResetReducerIntegrationInterface;
